import React from "react";

const Contact = () => {
  return (
    <div>
      <section className="contact-info-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="contact-info-one__single">
                <div className="contact-info-one__icon">
                  <i className="kipso-icon-manager"></i>
                </div>
                <h2 className="contact-info-one__title">关于我们</h2>
                <p className="contact-info-one__text">
                苏州卫捷医药科技有限公司 <br /> 
                专注于医院自动化领域软硬件系统开发 <br />
                 </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-info-one__single">
                <div className="contact-info-one__icon">
                  <i className="kipso-icon-placeholder"></i>
                </div>
                <h2 className="contact-info-one__title">地址</h2>
                <p className="contact-info-one__text">
                  江苏省苏州市 <br />
                  光福镇太湖产业园
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-info-one__single">
                <div className="contact-info-one__icon">
                  <i className="kipso-icon-contact"></i>
                </div>
                <h2 className="contact-info-one__title">联系方式</h2>
                <p className="contact-info-one__text">
                  szwjchen@foxmail.com<br />
                  400-8388183 
                </p>
              </div>
            </div>


          </div>
          <div><br/><br/></div>
        </div>
      </section>

    </div>
  );
};

export default Contact;
